import { get, isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Popover, Switch, Button } from 'antd';
import { sp_card_setting } from '../../../../../assets/img';
import { talentReviewApi } from '../../../../../services/talentReviewApi';
import { CheckboxFulfilment, Title, TitleEmptyState } from './fullFillmentStyled';
import { useSelector } from 'react-redux';

export default function Fullfillment(props) {
  const { staffId, data, positionSelected, agendaId, version, plan } = props;
  const roleActive = useSelector((state) => state.user.roleActive);
  const [dataRender, setDataRender] = useState([]);
  const [complementaryExperienceToggle, setComplementaryExperienceToggle] = useState(false);
  const [pendingComplementaryExperienceToggle, setPendingComplementaryExperienceToggle] = useState(false);
  const [fulfillmentSettingsOpen, setFulfillmentSettingsOpen] = useState(false);

  const next_mobility_codes = [...new Set([...data.next_mobility.selection.map((item) => item?.position_code?.toString())])];
  const next_2_mobility_codes = [...new Set([...data.next_2_mobility.selection.map((item) => item?.position_code?.toString())])];
  const position_code = [...new Set([...data.end_state.selection.map((item) => item?.position_code?.toString())])];
  useEffect(() => {
    if (!staffId || isEmpty(position_code)) return setDataRender([]);
    if (
      isNaN(Number(staffId)) ||
      next_mobility_codes.some((next) => isNaN(Number(next))) ||
      next_2_mobility_codes.some((next2) => isNaN(Number(next2)))
    )
      return setDataRender([]);
    (async function getFulfilment() {
      try {
        const res = await talentReviewApi.getCriteriaFulfilment({
          staff_id: Number(staffId),
          position_code: Number(position_code),
          next_mobility_codes: next_mobility_codes.map((m) => Number(m)),
          next_2_mobility_codes: next_2_mobility_codes.map((m) => Number(m)),
        });
        const endState = get(res, 'data.endStateData') || [];
        const nextMobility = get(res, 'data.nextMobilityData') || [];
        const next2Mobility = get(res, 'data.next2MobilityData') || [];

        const dataRender = [
          ...endState.map((item) => {
            return {
              isActive: item.dimension === 'Strength',
              ...item,
            };
          }),
        ];

        nextMobility.forEach((item) => {
          const existedEndstate = dataRender.find((endstate) => endstate?.content == item?.content);
          if (!existedEndstate) {
            dataRender.push({ ...item, isActive: item?.dimension === 'Strength' });
            return;
          }

          const isNewValueValid = item?.experience !== undefined && item?.experience !== null && item?.experience !== NaN;
          const existingIsInvalid =
            existedEndstate.experience !== existedEndstate.experience ||
            existedEndstate.experience === null ||
            existedEndstate.experience === undefined;
          if (isNewValueValid && existingIsInvalid) {
            existedEndstate.experience = item?.experience;
          }
          existedEndstate.isDot = item?.dimension === 'Strength';
          if (!existedEndstate.isDot) {
            existedEndstate.mobility_code = existedEndstate?.mobility_code
              ? existedEndstate.mobility_code + `,${item?.mobility_code}`
              : item?.mobility_code;
          }
          if (!existedEndstate.isActive) existedEndstate.isActive = item?.dimension === 'Gap';
          existedEndstate.hasSmallDotNextMobility = item?.experience === 'Functional';
          existedEndstate.dotColorNextMobility = existedEndstate.hasSmallDotNextMobility ? '#005CB9' : undefined;
        });
        next2Mobility.forEach((item) => {
          const existedEndstate = dataRender.find((endstate) => endstate?.content == item?.content);
          if (!existedEndstate) {
            dataRender.push({ ...item, isActive: item?.dimension === 'Strength' });
            return;
          }

          const isNewValueValid = item?.experience !== undefined && item?.experience !== null && item?.experience !== NaN;
          const existingIsInvalid =
            existedEndstate.experience !== existedEndstate.experience ||
            existedEndstate.experience === null ||
            existedEndstate.experience === undefined;
          if (isNewValueValid && existingIsInvalid) {
            existedEndstate.experience = item?.experience;
          }
          existedEndstate.isDot = item?.dimension === 'Strength';
          if (!existedEndstate.isDot) {
            existedEndstate.mobility_code = existedEndstate?.mobility_code
              ? existedEndstate.mobility_code + `,${item?.mobility_code}`
              : item?.mobility_code;
          }
          if (!existedEndstate.isActive) existedEndstate.isActive = item?.dimension === 'Gap';
          existedEndstate.hasSmallDotNext2Mobility = item?.experience === 'Functional';
          existedEndstate.dotColorNext2Mobility = existedEndstate.hasSmallDotNext2Mobility ? '#763F98' : undefined;
        });

        dataRender.forEach((ele) => {
          if (ele.isActive && ele.mobility_code) {
            const totalNextArray = [
              ...data.next_mobility.selection.map((ele) => ({
                ...ele,
                typeMobility: 'next_mobility',
              })),
              ...data.next_2_mobility.selection.map((ele) => ({
                ...ele,
                typeMobility: 'next_2_mobility',
              })),
            ];
            const totalNextArrayPriority = totalNextArray
              .filter((i) => ele.mobility_code.toString().includes(i.position_code?.toString()))
              .map((i) => i?.priority);
            const isPiorityMatching = isEmpty(totalNextArrayPriority) ? null : Math.min(...totalNextArrayPriority);
            const isPositionMobilityMatching = totalNextArray.find((ele) => ele.priority === isPiorityMatching);

            const hasNextMobility = totalNextArray.some((item) => item.typeMobility === 'next_mobility');
            const hasNext2Mobility = totalNextArray.some((item) => item.typeMobility === 'next_2_mobility');
            const isColorActive = hasNextMobility ? '#005CB9' : hasNext2Mobility ? '#763F98' : '#00a19c';

            ele.isColorActive = isColorActive;
            ele.highlightSelected = {
              typeMobility: isPositionMobilityMatching?.typeMobility,
              position_code: isPositionMobilityMatching?.position_code,
            };
          }
        });

        setDataRender(dataRender);
      } catch (error) {
        console.log(error);
        setDataRender([]);
      }
    })();
  }, [staffId, JSON.stringify(next_mobility_codes), JSON.stringify(next_2_mobility_codes), JSON.stringify(position_code)]);

  const handleApplyComplementaryExperienceToggle = () => {
    setComplementaryExperienceToggle(pendingComplementaryExperienceToggle);
    setFulfillmentSettingsOpen(false);

    if (agendaId && !isNaN(Number(agendaId))) {
      const criteriaFulfilmentSettings = {
        complementary: pendingComplementaryExperienceToggle,
      };
      talentReviewApi
        .updateCriteriaFulfilmentSettings(
          {
            agenda_id: agendaId,
            version: version || 0,
            staff_id: staffId,
            plan: plan,
            criteria_fulfilment_settings: criteriaFulfilmentSettings,
          },
          roleActive?.roleId,
        )
        .catch(console.error);
    }
  };

  const getCheckboxColor = (item) => {
    const baseColor = item.isActive && item.isColorActive ? item.isColorActive : item.isActive ? '#00a19c' : undefined;

    if (!complementaryExperienceToggle || !baseColor) {
      return { color: baseColor, tickOnly: false };
    }

    if (item.experience === 'Complementary') {
      return { color: baseColor, tickOnly: true };
    }

    return { color: baseColor, tickOnly: false };
  };

  return (
    <div>
      <Card
        style={{
          position: 'relative',
          width: '280px',
          minHeight: '260px',
          color: '#000',
          backgroundColor: '#FFFAEF',
          padding: '10px',
        }}
      >
        {!isEmpty(dataRender) && (
          <Popover
            trigger="click"
            visible={fulfillmentSettingsOpen}
            onVisibleChange={(visible) => {
              setFulfillmentSettingsOpen(visible);
              if (visible) setPendingComplementaryExperienceToggle(complementaryExperienceToggle);
            }}
            placement="rightTop"
            content={
              <div style={{ padding: '4px 8px' }}>
                <div style={{ fontFamily: 'Inter', fontSize: '12px', fontWeight: 600, marginBottom: '24px', color: '#67798a' }}>Show</div>
                <div className="d-flex justify-content-between align-items-center" style={{ gap: '12px', marginBottom: '24px' }}>
                  <Switch
                    checked={pendingComplementaryExperienceToggle}
                    onChange={(checked) => setPendingComplementaryExperienceToggle(checked)}
                    style={{ backgroundColor: `${pendingComplementaryExperienceToggle ? '#009089' : ''}` }}
                  />
                  <span style={{ fontFamily: 'Inter', fontSize: '14px', fontWeight: 600 }}>Complementary Experience</span>
                </div>
                <Button
                  style={{ background: '#00a19c', width: '100%', height: '36px', borderRadius: '6px' }}
                  type="primary"
                  size="small"
                  onClick={handleApplyComplementaryExperienceToggle}
                >
                  Apply
                </Button>
              </div>
            }
          >
            <div
              onClick={(e) => e.stopPropagation()}
              onKeyDown={() => {}}
              role="button"
              aria-label="Toggle complementary experience indicator"
              title="Fulfillment Settings"
              style={{
                width: '50px',
                height: '56px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: 'none',
                background: '#4f5f6e',
                cursor: 'pointer',
                position: 'absolute',
                right: '-1px',
                top: '-57px',
                borderTopRightRadius: '6px',
              }}
            >
              <img
                src={sp_card_setting}
                alt="fulfillment settings"
                style={{
                  height: '20px',
                }}
              />
            </div>
          </Popover>
        )}

        {!isEmpty(dataRender) && complementaryExperienceToggle && (
          <div
            className="d-flex flex-column"
            style={{
              gap: '6px',
              marginBottom: '10px',
              padding: '5px',
              width: '172px',
              marginLeft: 'auto',
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                gap: '10px',
                width: '100%',
              }}
            >
              <CheckboxFulfilment disabled checked color="#3d3d3d" tickOnly={false} style={{ width: 'auto', height: 'auto' }} />

              <span
                style={{
                  fontFamily: 'Inter',
                  fontSize: '10px',
                  fontWeight: 600,
                  color: '#006360',
                }}
              >
                Functional Experience
              </span>
            </div>

            <div
              className="d-flex align-items-center"
              style={{
                gap: '10px',
                width: '100%',
              }}
            >
              <CheckboxFulfilment disabled checked color="#3d3d3d" tickOnly={true} style={{ width: 'auto', height: 'auto' }} />

              <span
                style={{
                  fontFamily: 'Inter',
                  fontSize: '10px',
                  fontWeight: 600,
                  color: '#006360',
                }}
              >
                Complementary Experience
              </span>
            </div>
          </div>
        )}

        {!isEmpty(dataRender) &&
          dataRender.map((item, index) => (
            <div
              className="d-flex justify-content-start align-items-center"
              style={{
                gap: '10px',
                padding: '5px',
                border: '1px solid var(--Light-Gray-200, #EBEBEB)',
                backgroundColor:
                  item?.highlightSelected &&
                  positionSelected &&
                  item?.highlightSelected?.typeMobility === positionSelected?.typeMobility &&
                  item?.highlightSelected?.position_code === positionSelected?.position_code
                    ? '#F2F4F8'
                    : '#FFF',
              }}
              key={`fulfilment-${index}`}
            >
              <div
                className="col-10 d-flex justify-content-start"
                style={{
                  gap: '10px',
                }}
              >
                <CheckboxFulfilment
                  disabled
                  checked={item.isActive}
                  color={getCheckboxColor(item).color}
                  tickOnly={getCheckboxColor(item).tickOnly}
                />

                <Title isActive={item.isActive} color={getCheckboxColor(item).color}>
                  {item.content}
                </Title>
              </div>
              {(item.hasSmallDotNextMobility || item.hasSmallDotNext2Mobility) && (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 28 25" fill="none">
                  <path
                    d="M9.33203 12.3385C9.33203 13.0458 9.61298 13.7241 10.1131 14.2242C10.6132 14.7243 11.2915 15.0052 11.9987 15.0052C12.7059 15.0052 13.3842 14.7243 13.8843 14.2242C14.3844 13.7241 14.6654 13.0458 14.6654 12.3385C14.6654 11.6313 14.3844 10.953 13.8843 10.4529C13.3842 9.95283 12.7059 9.67188 11.9987 9.67188C11.2915 9.67188 10.6132 9.95283 10.1131 10.4529C9.61298 10.953 9.33203 11.6313 9.33203 12.3385V12.3385Z"
                    fill={item.hasSmallDotNextMobility ? item.dotColorNextMobility : item.dotColorNext2Mobility}
                  />
                </svg>
              )}
            </div>
          ))}
        {isEmpty(dataRender) && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              backgroundColor: '#FFFAEF',
              minHeight: '260px',
            }}
          >
            <TitleEmptyState>Enter end state to get the talent gap functions list</TitleEmptyState>
          </div>
        )}
      </Card>
    </div>
  );
}
